import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import waitForElement from '../utils/waitForElement';

const ShopPay = ({ currentVariant }) => {
  const currentVariantId = currentVariant?.id?.split('/').splice(-1)[0];
  const ref = useRef(null);
  const { enableShopPay } = JSON.parse(document.querySelector('[data-technical]').textContent);

	if (!enableShopPay) return null
  // Update the 'original' element with the current variant ID
  // Display the 'cloned' version to the user
  useEffect(() => {
    const findElements = setTimeout(async () => {
      const element = await waitForElement('.shopify-payment-terms-product shopify-payment-terms');
      element.setAttribute('variant-id', currentVariantId);
      const cloned = element.cloneNode(true);

      ref.current.append(cloned);
    }, 300);
    return () => clearTimeout(findElements);
  }, []);

  return (
		<div className="text-center atc-sticky:hidden">
			<div ref={ref} className={'shopify-payment-terms-product body-2 text-secondary pt-2'} />
		</div>
  );
};

export default ShopPay;